import { Link } from 'react-router-dom';
import { Mail, Phone, Car, User } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';

export interface CustomerSummary {
  id: string;
  name: string;
  phone?: string | null;
  email?: string | null;
}

export interface VehicleSummary {
  id: string;
  registration?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  color?: string | null;
}

interface Props {
  customer?: CustomerSummary | null;
  vehicle?: VehicleSummary | null;
  compact?: boolean;
}

export function CustomerVehicleSummary({ customer, vehicle, compact = false }: Props) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      {customer && (
        <Card>
          <CardHeader className={compact ? 'pb-3' : 'pb-4'}>
            <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-2">
              <User className="h-4 w-4" /> Cliente
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm">
            <Link to={`/customers/${customer.id}`} className="font-semibold text-primary hover:underline">
              {customer.name}
            </Link>
            {customer.phone && (
              <div className="flex items-center gap-2 text-muted-foreground">
                <Phone className="h-3.5 w-3.5" />
                <a href={`tel:${customer.phone}`} className="hover:text-primary">{customer.phone}</a>
              </div>
            )}
            {customer.email && (
              <div className="flex items-center gap-2 text-muted-foreground">
                <Mail className="h-3.5 w-3.5" />
                <a href={`mailto:${customer.email}`} className="truncate hover:text-primary">{customer.email}</a>
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {vehicle && (
        <Card>
          <CardHeader className={compact ? 'pb-3' : 'pb-4'}>
            <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-2">
              <Car className="h-4 w-4" /> Vehículo
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm">
            <div className="flex items-center gap-2">
              <Link to={`/vehicles/${vehicle.id}`} className="font-semibold text-primary hover:underline">
                {[vehicle.make, vehicle.model].filter(Boolean).join(' ') || 'Vehículo'}
              </Link>
              {vehicle.registration && <Badge variant="outline">{vehicle.registration}</Badge>}
            </div>
            {vehicle.year && <div className="text-muted-foreground">Año: {vehicle.year}</div>}
            {vehicle.color && <div className="text-muted-foreground">Color: {vehicle.color}</div>}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
